import { Box, LinearProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../Hooks/useAuth';
import { ROUTES } from '../../Utils/routes';

type Props = {
  children?: React.ReactNode;
};

const PrivateRoute: React.FC<Props> = ({ children }: Props) => {
  const { isAuthenticated, isLoading, oauthError } = useAuth();

  if (isLoading) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress color='secondary' />
      </Box>
    );
  }

  // If there's an OAuth error, redirect to sign-in to show the error
  if (oauthError && !isAuthenticated) {
    return <Navigate to={ROUTES.SIGN_IN} replace />;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to={ROUTES.SIGN_IN} replace />;
};

export default PrivateRoute;
